import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BATTLE_ROOMS_TABS = [{
    title: (
        <FormattedMessage
            id='battleRooms.tab.players_matching.title'
            defaultMessage='Подбор отряда'
        />
    ),
    id: 'battleRooms.tab.players_matching',
}, {
    title: (
        <FormattedMessage
            id='battleRooms.tab.unit_list.title'
            defaultMessage='Список отрядов'
        />
    ),
    id: 'battleRooms.tab.unit_list',
}]



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/Tabs/constants.jsx